@import "~@govbr-ds/core/src/components/menu/mixins";
@include menu-header;
@include menu-body;
@include menu-footer;
@include menu-items;
@include menu-side-menu;

:host {
  display: block;
}

// Ajustes de densidade propagados a partir do ancestral <br-menu>
// Densidade alta (small): itens mais compactos
:host-context(br-menu[density="small"]) .menu-item {
  padding-block: var(--spacing-scale-base);
}

// Densidade baixa (large): itens com maior espaçamento
:host-context(br-menu[density="large"]) .menu-item {
  padding-block: var(--spacing-scale-3x);
}

.divider-item {
  border-bottom: 1px solid var(--border-color);
}

a.menu-item.active {
  background-color: var(--active);
  --interactive: var(--color-dark);
  --interactive-rgb: var(--color-dark-rgb);
}
